const REQUIRED_TRANSIT_DAYS_COMPANY_IDS = new Set([
  "67c54941d01fd3b1d3d21530",
  "686becf5e5695daae65de088",
  "6710f00d365731c9d8b1bc77",
]);

export const isTransitDaysRequired = (companyId) =>
  REQUIRED_TRANSIT_DAYS_COMPANY_IDS.has(companyId);

